<template lang="pug">
    .container.content
        .column.is-offset-1.is-10
            div.password-wrapper(v-if="password !== false && solvedPassword === false")
                p Der nachfolgende Download ist mit einem Passwort gesichert. Bitte das Passwort eingeben.
                .field.control
                    input.input(type="password" @keyup="checkPassword")
            ul.no-style-list
                MediaPreview(
                    v-for="content in contents"
                    :key="content.id"
                    :media="content.media[0]"
                    :height="64"
                    :width="61"
                    :showDownload="showDownload"
                )
</template>

<script>
import _ from 'lodash'

import MediaPreview from './MediaPreview'

export default {
    name: 'Downloads',
    data() {
        return {
            solvedPassword: false
        }
    },
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    components: {
        MediaPreview
    },
    computed: {
        contents() {
            let contents = _.get(this.section, 'contents') || []

            const isValidMediaObject = media => {
                let isValid = false
                switch (media.type) {
                    case 'file':
                        isValid = !! _.get(media, 'file')
                        break
                    case 'image':
                    case 'video':
                        isValid = !! _.get(media, `${media.type}.source`)
                        break
                }
                return isValid
            }


            contents = _.cloneDeep(contents).filter(content => {
                return content.media && content.media.length === 1 &&
                    isValidMediaObject(content.media[0])
            }).sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0))

            return contents
        },
        password() {
            let password = false;
            if ( !this.section || !this.section.settings ) return password;
            const passwordSetting = this.section.settings.find( setting => {
                return setting.key === 'password'
            } ) || false;
            if ( passwordSetting && passwordSetting.value && ( passwordSetting.value !== null || passwordSetting.value !== '' ) ) password = passwordSetting.value
            return password;
        },
        showDownload() {
            let showDownload = true;
            if ( this.password ) showDownload = false;
            if ( this.password && this.solvedPassword ) showDownload= true;
            return showDownload;
        }
    },
    methods: {
        checkPassword(input) {
            if ( !this.password || this.solvedPassword ) return;
            const inputValue = input.target.value;
            if ( inputValue !== this.password ) return;
            this.solvedPassword = true;
        }
    }
}
</script>

<style lang="sass" scoped>
    
.password-wrapper
    text-align: center
    .field
        max-width: 250px
        margin: auto
        margin-top: 25px
        margin-bottom: 25px
</style>
